import { ReactElement, useMemo } from 'react';
import styles from './device-page.module.scss';
import { Navigate, useSearchParams } from 'react-router';
import { DeviceDetail } from '@/devices/components';
import SafepointLogo from '@/common/assets/images/safepoint-logo-dark.svg?react';
import { UISpacer } from '@/ui';
import { normaliseObjectId } from '@/common/util/object-id';

export function DevicePage(): ReactElement {
    const [searchParams] = useSearchParams();
    const deviceId = useMemo(() => {
        const id = searchParams.get('deviceId') || searchParams.get('id');
        return id ? normaliseObjectId(id) : null;
    }, [searchParams]);

    if (!deviceId) {
        return <Navigate to="/" replace />;
    }

    return (
        <div className={styles.page}>
            <SafepointLogo width={300} />
            <UISpacer multiplier={4} />
            <div className={styles.deviceDetailCard}>
                <DeviceDetail deviceId={deviceId} />
            </div>
        </div>
    );
}
